import { objectSchemaOf, Joi } from '../helpers';
import type { IRecordingHeader } from './recording';
import type { IErrorResponse } from '../apps';

export interface IPrepareToDownloadParams {
  recordingIds: string[];
}

export const prepareToDownloadParamsSchema = objectSchemaOf<IPrepareToDownloadParams>(
  {
    recordingIds: Joi.array().items(Joi.string()).required(),
  }
);

export interface IPrepareToDownloadResult {
  recordings: Array<IRecordingHeader | IErrorResponse>;
}
